import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CtaSection = ({ title = "Un nuisible chez vous ?", subtitle = "Ne laissez pas l'infestation s'installer. Tarifs clairs et affichés, intervention possible sous 2h, 7j/7." }) => {
    return (
        <section data-testid="cta-section" className="relative overflow-hidden py-24 md:py-32">
            <div className="absolute inset-0 bg-brand" aria-hidden="true" />
            <div className="absolute -left-32 top-1/2 h-96 w-96 -translate-y-1/2 rounded-full bg-white/10 blur-[140px]" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal>
                    <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-white/80">
                        <span className="h-px w-8 bg-white/60" />
                        Tarifs transparents
                    </span>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-6 max-w-3xl font-display text-4xl font-black uppercase leading-[1.05] tracking-tight text-white sm:text-6xl">
                        {title}
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-white/85 sm:text-lg">{subtitle}</p>
                </Reveal>
                <Reveal delay={0.3} className="mt-10 flex flex-wrap items-center gap-4">
                    <Link
                        data-testid="cta-devis-button"
                        to="/tarifs"
                        className="inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 font-bold text-brand transition-[background-color,transform] duration-300 hover:bg-slate-100 hover:scale-105 active:scale-95"
                    >
                        Voir les tarifs
                        <ArrowRight className="h-5 w-5" />
                    </Link>
                    <a
                        data-testid="cta-phone-button"
                        href="tel:+33255992243"
                        className="inline-flex items-center gap-2 rounded-full border border-white/40 px-8 py-4 font-bold text-white transition-[border-color,background-color] duration-300 hover:border-white hover:bg-white/10"
                    >
                        <Phone className="h-5 w-5 text-white" />
                        02 55 99 22 43
                    </a>
                </Reveal>
            </div>
        </section>
    );
};

export default CtaSection;
